import _toConsumableArray from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.reduce.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray } from 'vega-util';
import { isBinning } from '../bin';
import { isScaleFieldDef, isTimeFormatFieldDef, vgField } from '../channeldef';
import { ScaleType } from '../scale';
import { formatExpression } from '../timeunit';
import { QUANTITATIVE } from '../type';
import { getFirstDefined, stringify } from '../util';
export function applyMarkConfig(e, model, propsList) {
  var _iterator = _createForOfIteratorHelper(propsList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;
      var value = getMarkConfig(property, model.markDef, model.config);

      if (value !== undefined) {
        e[property] = {
          value: value
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return e;
}
export function getStyles(mark) {
  return [].concat(mark.type, mark.style || []);
}
/**
 * Return property value from style or mark specific config property if exists.
 * Otherwise, return general mark specific config.
 */

export function getMarkConfig(channel, mark, config) // Note: Ham: I use `any` here as it's too hard to make TS knows that MarkConfig[vgChannel] would have the same type as MarkConfig[P]
{
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      vgChannel = _ref.vgChannel;

  return getFirstDefined( // style config has highest precedence
  vgChannel ? getStyleConfig(channel, mark, config.style) : undefined, getStyleConfig(channel, mark, config.style), // then mark-specific config
  vgChannel ? config[mark.type][vgChannel] : undefined, config[mark.type][channel], // If there is vgChannel, skip vl channel.
  // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
  vgChannel ? config.mark[vgChannel] : config.mark[channel]);
}
export function getStyleConfig(prop, mark, styleConfigIndex) {
  var styles = getStyles(mark);
  var value;

  var _iterator2 = _createForOfIteratorHelper(styles),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var style = _step2.value;
      var styleConfig = styleConfigIndex[style]; // MarkConfig extends VgMarkConfig so a prop may not be a valid property for style
      // However here we also check if it is defined, so it is okay to cast here

      var p = prop;

      if (styleConfig && styleConfig[p] !== undefined) {
        value = styleConfig[p];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return value;
}
export function formatSignalRef(fieldDef, specifiedFormat, expr, config) {
  if (isTimeFormatFieldDef(fieldDef)) {
    var isUTCScale = isScaleFieldDef(fieldDef) && fieldDef['scale'] && fieldDef['scale'].type === ScaleType.UTC;
    return {
      signal: timeFormatExpression(vgField(fieldDef, {
        expr: expr
      }), fieldDef.timeUnit, specifiedFormat, config.text.shortTimeLabels, config.timeFormat, isUTCScale, true)
    };
  } else {
    var format = numberFormat(fieldDef, specifiedFormat, config);

    if (isBinning(fieldDef.bin)) {
      var startField = vgField(fieldDef, {
        expr: expr
      });
      var endField = vgField(fieldDef, {
        expr: expr,
        binSuffix: 'end'
      });
      return {
        signal: binFormatExpression(startField, endField, format, config)
      };
    } else if (fieldDef.type === 'quantitative' || format) {
      return {
        signal: "".concat(formatExpr(vgField(fieldDef, {
          expr: expr,
          binSuffix: 'range'
        }), format))
      };
    } else {
      return {
        signal: "''+".concat(vgField(fieldDef, {
          expr: expr
        }))
      };
    }
  }
}
/**
 * Returns number format for a fieldDef
 */

export function numberFormat(fieldDef, specifiedFormat, config) {
  // Specified format in axis/legend has higher precedence than fieldDef.format
  if (specifiedFormat) {
    return specifiedFormat;
  }

  if (fieldDef.type === QUANTITATIVE) {
    // we only apply the default if the field is quantitative
    return config.numberFormat;
  }

  return undefined;
}

function formatExpr(field, format) {
  return "format(".concat(field, ", \"").concat(format || '', "\")");
}

export function numberFormatExpr(field, specifiedFormat, config) {
  return formatExpr(field, specifiedFormat || config.numberFormat);
}
export function binFormatExpression(startField, endField, format, config) {
  return "".concat(startField, " === null || isNaN(").concat(startField, ") ? \"null\" : ").concat(numberFormatExpr(startField, format, config), " + \" - \" + ").concat(numberFormatExpr(endField, format, config));
}
/**
 * Returns the time expression used for axis/legend labels or text mark for a temporal field
 */

export function timeFormatExpression(field, timeUnit, format, shortTimeLabels, rawTimeFormat, // should be provided only for actual text and headers, not axis/legend labels
isUTCScale) {
  var alwaysReturn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  if (!timeUnit || format) {
    // If there is not time unit, or if user explicitly specify format for axis/legend/text.
    format = format || rawTimeFormat; // only use provided timeFormat if there is no timeUnit.

    if (format || alwaysReturn) {
      return "".concat(isUTCScale ? 'utc' : 'time', "Format(").concat(field, ", '").concat(format, "')");
    } else {
      return undefined;
    }
  } else {
    return formatExpression(timeUnit, field, shortTimeLabels, isUTCScale);
  }
}
/**
 * Return Vega sort parameters (tuple of field and order).
 */

export function sortParams(orderDef, fieldRefOption) {
  return (isArray(orderDef) ? orderDef : [orderDef]).reduce(function (s, orderChannelDef) {
    s.field.push(vgField(orderChannelDef, fieldRefOption));
    s.order.push(orderChannelDef.sort || 'ascending');
    return s;
  }, {
    field: [],
    order: []
  });
}
export function mergeTitleFieldDefs(f1, f2) {
  var merged = _toConsumableArray(f1);

  f2.forEach(function (fdToMerge) {
    var _iterator3 = _createForOfIteratorHelper(merged),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var fieldDef1 = _step3.value;

        // If already exists, no need to append to merged array
        if (stringify(fieldDef1) === stringify(fdToMerge)) {
          return;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    merged.push(fdToMerge);
  });
  return merged;
}
export function mergeTitle(title1, title2) {
  if (title1 === title2 || !title2) {
    // if titles are the same or title2 is falsy
    return title1;
  } else if (!title1) {
    // if title1 is falsy
    return title2;
  } else {
    // join title with comma if they are different
    return title1 + ', ' + title2;
  }
}
export function mergeTitleComponent(v1, v2) {
  if (isArray(v1.value) && isArray(v2.value)) {
    return {
      explicit: v1.explicit,
      value: mergeTitleFieldDefs(v1.value, v2.value)
    };
  } else if (!isArray(v1.value) && !isArray(v2.value)) {
    return {
      explicit: v1.explicit,
      value: mergeTitle(v1.value, v2.value)
    };
  }
  /* istanbul ignore next: Condition should not happen -- only for warning in development. */


  throw new Error('It should never reach here');
}